import React, { useEffect, useState } from "react";
import { db } from "../firebase"; // Adjust the path to your firebase config
import { collection, getDocs, updateDoc, doc } from "firebase/firestore";
import "./walletmanagement.css"; // Create a CSS file for styling if needed

const WalletManagement = () => {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Fetch all users and their wallet balances
  useEffect(() => {
    const fetchUsers = async () => {
      setIsLoading(true);
      const usersCollection = collection(db, "users");
      const userSnapshot = await getDocs(usersCollection);
      const userList = userSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setUsers(userList);
      setIsLoading(false);
    };

    fetchUsers();
  }, []);

  // Update wallet balance for a user
  const updateWalletBalance = async (userId, newBalance) => {
    try {
      const userRef = doc(db, "users", userId);
      await updateDoc(userRef, { walletBalance: Number(newBalance) });
      alert("Wallet balance updated successfully!");

      // Update state to reflect changes
      setUsers((prevUsers) =>
        prevUsers.map((user) =>
          user.id === userId
            ? { ...user, walletBalance: Number(newBalance) }
            : user
        )
      );
    } catch (error) {
      console.error("Error updating wallet balance:", error);
      alert("Failed to update wallet balance.");
    }
  };

  return (
    <div className="wallet-management">
      <h2>Wallet Management</h2>
      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <table className="wallet-table">
          <thead>
            <tr>
              <th>User Name</th>
              <th>Email</th>
              <th>Wallet Balance</th>
              <th>Update Balance</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.id}>
                <td>{user.username}</td>
                <td>{user.email}</td>
                <td>₹{user.walletBalance}</td>
                <td>
                  <input
                    type="number"
                    defaultValue={user.walletBalance}
                    onChange={(e) => (user.newBalance = e.target.value)}
                  />
                  <button
                    onClick={() =>
                      updateWalletBalance(user.id, user.newBalance)
                    }
                  >
                    Update
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default WalletManagement;
